// @flow

import _ from 'underscore';

import GlassInfo from './GlassInfo';
import t from "./trans";
import {calcAngle} from "./util";
import type {IntegerType} from "./model";
import Settings from "./Grobot/Settings";
import AppConfig from "./config";
import ProductConfig from "./ProductConfig";
import ProductTransformer from "./ProductTransformer";


/**
 * Nurga tolerantsid
 */
type AngleTolerancesType = {
	pYlemineTolerants2: string,
	pYlemineTolerants1: string,
	pNominaal: string,
	pAlumineTolerants1: string,
	pAlumineTolerants2: string
};

/**
 * Tooteinfo struktuur
 */
type ProductInfoType = {
	glass: GlassInfo,
	/**
	 * Joonte arv
	 */
	lineCount: IntegerType,
    /**
     * HUD punktide jaoks kasutatav joon (1..n)
     */
    hudLine: ?IntegerType,
    /**
     * HUD punktide arv
     */
    hudPoints: IntegerType,
	/**
	 * Täiendavate punktide arv keskmisel joonel
	 */
	addPoints: IntegerType,
	/**
	 * Sisseloetud NCP faili nimi
	 */
	failiNimi: string,
	/**
	 * Sisseloetud NCP faili sisu
	 */
	ncpData: ?string,
	/**
	 * Sisseloetud NCP faili tüüp - kas dat või ncp.
	 */
	ncpType: ?string,
	/**
	 * Sisseloetud GR2 faili nimi
	 */
	grFailiNimi: string,
	/**
	 * Mudeli nimi
	 */
	mudeliNimi: string,	// mudeliNimi (4920, 330, w: 4695)
	/**
	 * SCAN
	 */
	scan: string,	// SCAN (9960, 330, w:1935)
	/**
	 * kood = programm + versioon
	 */
	kood: string,		// kood = programm + versioon
	/**
	 * X nihe
	 */
	xnihe: IntegerType,		// Text49 (1080, 3600, w:495)
	/**
	 * Y nihe
	 */
	ynihe: IntegerType,		// Text50 (1080, 3960, w:495)
	/**
	 * Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
	 */
	xdiff: IntegerType,
	/**
	 * Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
	 */
	ydiff: IntegerType,
	/**
	 * GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
	 */
	enihe: IntegerType,
	/**
	 * Distants
	 */
	distants: IntegerType,	// Text61 (1080, 4440, w:495)
	/**
	 * Raadionupud e1, e2, e5, e6
	 */
	valitud_e: IntegerType,	// raadionupud e1, e2, e5, e6
	/**
	 * Raadionupud 1, 3, 4, 6, 7, 9
	 */
	valitud_p: IntegerType,	// raadionupud 1, 3, 4, 6, 7, 9
    /**
     * HUD raadionupud
     */
    valitud_hud: IntegerType,
	/**
	 * Tolerants 1 punktidele 2, 5, 8, 11, 14
	 */
	tolerants1k: IntegerType,	// Text51 (1440, 5160, w:495)
	/**
	 * Tolerants 2 punktidele 2, 5, 8, 11, 14
	 */
	tolerants2k: IntegerType,	// Text52 (1440, 5520, w:495)
	/**
	 * Tolerants 1 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
	 */
	tolerants1s: IntegerType,	// Text60 (3720, 5160, w:495)
	/**
	 * Tolerants 2 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
	 */
	tolerants2s: IntegerType,	// Text59 (3720, 5520, w:495)
	// pKoordY
	/**
	 * Punktide P offsetid klaasi ülemisest servast (punktidest e2, e4, e6)
	 */
	pv: Array<IntegerType>,	// PkoordY (960, 6240, w:495) - (960, 8160, w:495) 9tk
    /**
     * Punktide HUD offsetid klaasi ülemisest servast (punktist e4)
     */
    hudv: Array<IntegerType>,
	/**
	 * Punktide P korrektsioonid
	 */
	pKorrektsioon: Array<IntegerType>,	// korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
    /**
     * HUD punktide korrektsioonid
     */
    hudKorrektsioon: Array<IntegerType>,	// korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
	/**
	 * Klaasi paksus
	 */
	klaasiPaksus: IntegerType,	// klPaksus (4080, 6480, w:495)
	/**
	 * Profiil klaasil
	 */
	profiilKlaasil: IntegerType,	// profiilKlaasil (4080, 7080, w:495)
	/**
	 * Profiil trükil
	 */
	profiilTrykil: IntegerType,
	/**
	 * Servade X koordinaadid (eKoordX = ex + xnihe)
	 */
	ex: Array<IntegerType>,			// EkoordX, ex  (480, 8760, w:495) -  (480, 9960, w:495) 6tk
	/**
	 * Servade Y koordinaadid (eKoordY = ey + ynihe)
	 */
	ey: Array<IntegerType>,	// EkoordY, ey  (960, 8760, w:495) -  (960, 9960, w:495) 6tk

	// EkoordZ, ez (1440, 8760, w:495) - (1440, 9960, w:495) 6tk
	/**
	 * Servade Z koordinaadid (eKoordZ = eKoordK = ez)
	 */
	ez: Array<IntegerType>,	// EkoordK (2040, 8760, w:495) - (2040, 9960, w:495) 6tk
	/**
	 * KalleA
	 */
	eKalleA: Array<IntegerType>,	// KalleA  (2670, 8760, w:495) - (2670, 9960, w:495) 6tk
	/**
	 * KalleB
	 */
	eKalleB: Array<IntegerType>,	// KalleB  (3150, 8760, w:495) - (3150, 9960, w:495) 6tk
	/**
	 * eTrykk
	 */
	s: Array<IntegerType>,		// Trykk   (3750, 8760, w:495) - (3750, 9960, w:495) 6tk
	/**
	 * ePikkus = pikkus
	 */
	pikkus: Array<IntegerType>,	// Pikkus  (4350, 8760, w:495) - (4350, 9720, w:495) 3tk

	/**
	 * Kas antud P punkt on kasutuses
	 */
	pOlemas: Array<boolean>,
	/**
	 * P punktide x koordinaadid
	 */
	px: Array<IntegerType>,
	/**
	 * P punktide y koordinaadid
	 */
	py: Array<IntegerType>,

    hudx: Array<IntegerType>,
    hudy: Array<IntegerType>,

	/**
	 * P punktide nimed (P1 ... P9/P15, [P50, P100, P150, P200, P250])
	 */
	pNimi: Array<string>,

	/**
	 * P punktide asukohajooned (0 ... 3/5)
	 */
	pJoon: Array<IntegerType>,

	/**
	 * Ülemine tolerants 2
	 */
	pYlemineTolerants2: Array<IntegerType>,	// PtolYla2 (720, 10560, w:495) - (4200, 10560, w:495) 9tk
	/**
	 * Ülemine tolerants 1
	 */
	pYlemineTolerants1: Array<IntegerType>,	// PtolYla1 (720, 10800, w:495) - (4200, 10800, w:495) 9tk
	/**
	 * Nominaalid
	 */
	pNominaal: Array<IntegerType>,			// PtolNom  (720, 11040, w:495) - (4200, 11040, w:495) 9tk
	/**
	 * Alumine tolerants 1
	 */
	pAlumineTolerants1: Array<IntegerType>,
	/**
	 * Alumine tolerants 2
	 */
	pAlumineTolerants2: Array<IntegerType>,	// PtolAll2 (720, 11520, w:495) - (4200, 11520, w:495) 9tk

    /**
     * HUD Ülemine tolerants 2
     */
    hudYlemineTolerants2: Array<IntegerType>,
    /**
     * HUD Ülemine tolerants 1
     */
    hudYlemineTolerants1: Array<IntegerType>,
    /**
     * HUD Nominaalid
     */
    hudNominaal: Array<IntegerType>,
    /**
     * HUD Alumine tolerants 1
     */
    hudAlumineTolerants1: Array<IntegerType>,
    /**
     * HUD Alumine tolerants 2
     */
    hudAlumineTolerants2: Array<IntegerType>,

	/**
	 * Nurga tolerantsid
	 */
	angle: AngleTolerancesType,

	/**
	 * Kas punkt on valitud nurga arvutamiseks
	 */
	anglePoints: Array<boolean>,
	/**
	 * Kahe valitud punkti vahele tõmmatud joone nurk (arvutatud anglePoints punktide andmetest), kui null - siis pole täpselt kahte punkti valitud
	 */
	angleValue: ?number,

	/**
	 * ADAS punkti indeks
	 */
	adas: ?IntegerType,

	/**
	 * Joonte alumised koordinaadid
	 */
	joona: Array<IntegerType>,
	/**
	 * Joonte ülemised koordinaadid
	 */
	joony: Array<IntegerType>,

	/**
	 * Kas on keeratud 180 kraadi
	 */
	keeratud: boolean,
	/**
	 * Kas on peegeldatud
	 */
	peegeldatud: boolean,
	/**
	 * Kas on keeratud 90 kraadi
	 */
	rotated: boolean,
	/**
	 * Kas esimese mõõtejoone mõõtmisel tuleb sensorit pöörata
	 */
	keeratud_esimene: boolean,
	/**
	 * Kas viimase mõõtejoone mõõtmisel tuleb sensorit pöörata
	 */
	keeratud_viimane: boolean
};

/**
 * Tooteinfo klass
 */
class ProductInfo extends ProductConfig {
	glass: GlassInfo;
    /**
     * HUD punktide jaoks kasutatav joon (1..n)
     */
    hudLine: ?IntegerType;
	/**
	 * Sisseloetud NCP faili nimi
	 */
	failiNimi: string;
	/**
	 * Sisseloetud NCP faili sisu
	 */
	ncpData: ?string;
	/**
	 * Sisseloetud NCP faili tüüp - kas dat või ncp.
	 */
	ncpType: ?string;
	/**
	 * Sisseloetud GR2 faili nimi
	 */
	grFailiNimi: string;
	/**
	 * Mudeli nimi
	 */
	mudeliNimi: string;	// mudeliNimi (4920, 330, w: 4695)
	/**
	 * SCAN
	 */
	scan: string;	// SCAN (9960, 330, w:1935)
	/**
	 * kood = programm + versioon
	 */
	kood: string;		// kood = programm + versioon
	/**
	 * X nihe
	 */
	xnihe: number;		// Text49 (1080, 3600, w:495)
	/**
	 * Y nihe
	 */
	ynihe: number;		// Text50 (1080, 3960, w:495)
	/**
	 * Klaasi joone max ja min x koordinaatide vahe. Ei edastata PLCsse
	 */
	xdiff: number;
	/**
	 * Klaasi joone max ja min y koordinaatide vahe. Ei edastata PLCsse
	 */
	ydiff: number;
	/**
	 * GR2 faili enihe parameeter. Ignoreeritakse, ei edastata PLCsse
	 */
	enihe: number;
	/**
	 * Distants
	 */
	distants: number;	// Text61 (1080, 4440, w:495)
	/**
	 * Raadionupud e1, e2, e5, e6
	 */
	valitud_e: IntegerType;	// raadionupud e1, e2, e5, e6
	/**
	 * Raadionupud 1, 3, 4, 6, 7, 9
	 */
	valitud_p: IntegerType;	// raadionupud 1, 3, 4, 6, 7, 9
    /**
     * HUD raadionupud
     */
    valitud_hud: IntegerType;
	/**
	 * Tolerants 1 punktidele 2, 5, 8, 11, 14
	 */
	tolerants1k: number;	// Text51 (1440, 5160, w:495)
	/**
	 * Tolerants 2 punktidele 2, 5, 8, 11, 14
	 */
	tolerants2k: number;	// Text52 (1440, 5520, w:495)
	/**
	 * Tolerants 1 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
	 */
	tolerants1s: number;	// Text60 (3720, 5160, w:495)
	/**
	 * Tolerants 2 punktidele 1, 3, 4, 6, 7, 9, 10, 12, 13, 15
	 */
	tolerants2s: number;	// Text59 (3720, 5520, w:495)
    /**
     * Tolerants 1 lisapunktidele
     */
    tolerants1l: number;
    /**
     * Tolerants 2 lisapunktidele
     */
    tolerants2l: number;
    /**
     * Tolerants 1 HUD punktidele
     */
    tolerants1h: number;
    /**
     * Tolerants 2 HUD punktidele
     */
    tolerants2h: number;

	// pKoordY
	/**
	 * Punktide P offsetid klaasi ülemisest servast (punktidest e2, e4, e6)
	 */
	pv: Array<number>;	// PkoordY (960, 6240, w:495) - (960, 8160, w:495) 9tk
    hudv: Array<number>;
	/**
	 * Punktide P korrektsioonid
	 */
	pKorrektsioon: Array<number>;	// korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
    /**
     * HUD punktide korrektsioonid
     */
    hudKorrektsioon: Array<number>;
	/**
	 * Klaasi paksus
	 */
	klaasiPaksus: number;	// klPaksus (4080, 6480, w:495)
	/**
	 * Profiil klaasil
	 */
	profiilKlaasil: number;	// profiilKlaasil (4080, 7080, w:495)
	/**
	 * Profiil trükil
	 */
	profiilTrykil: number;
	/**
	 * Servade X koordinaadid (eKoordX = ex + xnihe)
	 */
	ex: Array<number>;			// EkoordX, ex  (480, 8760, w:495) -  (480, 9960, w:495) 6tk
	/**
	 * Servade Y koordinaadid (eKoordY = ey + ynihe)
	 */
	ey: Array<number>;	// EkoordY, ey  (960, 8760, w:495) -  (960, 9960, w:495) 6tk

	// EkoordZ, ez (1440, 8760, w:495) - (1440, 9960, w:495) 6tk
	/**
	 * Servade Z koordinaadid (eKoordZ = eKoordK = ez)
	 */
	ez: Array<number>;	// EkoordK (2040, 8760, w:495) - (2040, 9960, w:495) 6tk
	/**
	 * KalleA
	 */
	eKalleA: Array<number>;	// KalleA  (2670, 8760, w:495) - (2670, 9960, w:495) 6tk
	/**
	 * KalleB
	 */
	eKalleB: Array<number>;	// KalleB  (3150, 8760, w:495) - (3150, 9960, w:495) 6tk
	/**
	 * eTrykk
	 */
	s: Array<number>;		// Trykk   (3750, 8760, w:495) - (3750, 9960, w:495) 6tk
	/**
	 * ePikkus = pikkus
	 */
	pikkus: Array<number>;	// Pikkus  (4350, 8760, w:495) - (4350, 9720, w:495) 3tk

	/**
	 * Kas antud P punkt on kasutuses
	 */
	pOlemas: Array<boolean>;
	/**
	 * P punktide x koordinaadid
	 */
	px: Array<number>;
	/**
	 * P punktide y koordinaadid
	 */
	py: Array<number>;

    hudx: Array<number>;
    hudy: Array<number>;

	/**
	 * P punktide nimed (P1 ... P9/P15, [P50, P100, P150, P200, P250])
	 */
	pNimi: Array<string>;

	/**
	 * P punktide asukohajooned (0 ... 3/5)
	 */
	pJoon: Array<number>;

	/**
	 * Ülemine tolerants 2
	 */
	pYlemineTolerants2: Array<number>;	// PtolYla2 (720, 10560, w:495) - (4200, 10560, w:495) 9tk
	/**
	 * Ülemine tolerants 1
	 */
	pYlemineTolerants1: Array<number>;	// PtolYla1 (720, 10800, w:495) - (4200, 10800, w:495) 9tk
	/**
	 * Nominaalid
	 */
	pNominaal: Array<number>;			// PtolNom  (720, 11040, w:495) - (4200, 11040, w:495) 9tk
	/**
	 * Alumine tolerants 1
	 */
	pAlumineTolerants1: Array<number>;
	/**
	 * Alumine tolerants 2
	 */
	pAlumineTolerants2: Array<number>;	// PtolAll2 (720, 11520, w:495) - (4200, 11520, w:495) 9tk

    /**
     * HUD Ülemine tolerants 2
     */
    hudYlemineTolerants2: Array<number>;
    /**
     * HUD Ülemine tolerants 1
     */
    hudYlemineTolerants1: Array<number>;
    /**
     * HUD Nominaalid
     */
    hudNominaal: Array<number>;
    /**
     * HUD Alumine tolerants 1
     */
    hudAlumineTolerants1: Array<number>;
    /**
     * HUD Alumine tolerants 2
     */
    hudAlumineTolerants2: Array<number>;

	/**
	 * Nurga tolerantsid
	 */
	angle: AngleTolerancesType;

	/**
	 * Kas punkt on valitud nurga arvutamiseks
	 */
	anglePoints: Array<boolean>;
	/**
	 * Kahe valitud punkti vahele tõmmatud joone nurk (arvutatud anglePoints punktide andmetest), kui null - siis pole täpselt kahte punkti valitud
	 */
	angleValue: ?number;

	/**
	 * ADAS punkti indeks
	 */
	adas: ?IntegerType;

	/**
	 * Joonte alumised koordinaadid
	 */
	joona: Array<number>;
	/**
	 * Joonte ülemised koordinaadid
	 */
	joony: Array<number>;

	/**
	 * Kas on keeratud 180 kraadi
	 */
	keeratud: boolean;
	/**
	 * Kas on peegeldatud
	 */
	peegeldatud: boolean;
	/**
	 * Kas on keeratud 90 kraadi
	 */
	rotated: boolean;
	/**
	 * Kas esimese mõõtejoone mõõtmisel tuleb sensorit pöörata
	 */
	keeratud_esimene: boolean;
	/**
	 * Kas viimase mõõtejoone mõõtmisel tuleb sensorit pöörata
	 */
	keeratud_viimane: boolean;
	/**
	 * ADAS ala punktide distantsid klaasi servast
	 * @type {Array[number]}
	 */
	adasarea_distance: Array[number];
	/**
	 * ADAS ala punkti tüüp: 0 - klaas, 1 - print
	 * @type {Array[string]}
	 */
	adasarea_type: Array[string];

	/**
     *
     * @param state
     */
	constructor(state: ProductConfig | ProductInfoType | ProductInfo) {
        super(state);

        this.glass = new GlassInfo();
		this.failiNimi = '';
		this.ncpData = null;
		this.ncpType = null;
		this.grFailiNimi = '';
		this.mudeliNimi = '';	// mudeliNimi (4920, 330, w: 4695)
		this.scan = '';	// SCAN (9960, 330, w:1935)
		this.kood = '';		// kood = programm + versioon
		this.xnihe = null;		// Text49 (1080, 3600, w:495)
		this.ynihe = null;		// Text50 (1080, 3960, w:495)
        this.xdiff = null;
        this.ydiff = null;
        this.enihe = null;
		this.distants = null;	// Text61 (1080, 4440, w:495)
		this.valitud_e = null;	// raadionupud e1, e2, e5, e6
		this.valitud_p = null;	// raadionupud 1, 3, 4, 6, 7, 9
        this.valitud_hud = null;
		this.tolerants1k = null;	// Text51 (1440, 5160, w:495)
		this.tolerants2k = null;	// Text52 (1440, 5520, w:495)
		this.tolerants1s = null;	// Text60 (3720, 5160, w:495)
		this.tolerants2s = null;	// Text59 (3720, 5520, w:495)
        this.tolerants1l = null;
        this.tolerants2l = null;
        this.tolerants1h = null;
        this.tolerants2h = null;
		this.pv = [];	// PkoordY (960, 6240, w:495) - (960, 8160, w:495) 9tk
        this.hudv = [];
		this.pKorrektsioon = [];	// korrektsioon (2040, 6240, w:495) - (2040, 8160, w: 495) 9tk
        this.hudKorrektsioon = [];
		this.klaasiPaksus = null;	// klPaksus (4080, 6480, w:495)
		this.profiilKlaasil = null;	// profiilKlaasil (4080, 7080, w:495)
		this.profiilTrykil = null;
		this.ex = [];			// EkoordX, ex  (480, 8760, w:495) -  (480, 9960, w:495) 6tk
		this.ey = [];	// EkoordY, ey  (960, 8760, w:495) -  (960, 9960, w:495) 6tk
		this.ez = [];	// EkoordK (2040, 8760, w:495) - (2040, 9960, w:495) 6tk
		this.eKalleA = [];	// KalleA  (2670, 8760, w:495) - (2670, 9960, w:495) 6tk
		this.eKalleB = [];	// KalleB  (3150, 8760, w:495) - (3150, 9960, w:495) 6tk
		this.s = [];		// Trykk   (3750, 8760, w:495) - (3750, 9960, w:495) 6tk
		this.pikkus = [];	// Pikkus  (4350, 8760, w:495) - (4350, 9720, w:495) 3tk
		this.pOlemas = [];
		this.px = [];
		this.py = [];
        this.hudx = [];
        this.hudy = [];
		this.pNimi = [];
		this.pJoon = [];
		this.pYlemineTolerants2 = [];
		this.pYlemineTolerants1 = [];
		this.pNominaal = [];
		this.pAlumineTolerants1 = [];
		this.pAlumineTolerants2 = [];
        this.hudYlemineTolerants2 = [];
        this.hudYlemineTolerants1 = [];
        this.hudNominaal = [];
        this.hudAlumineTolerants1 = [];
        this.hudAlumineTolerants2 = [];
		this.angle = {};
		this.anglePoints = [];
		this.angleValue = null;
		this.adas = null;
		this.joona = [];
		this.joony = [];
		this.keeratud = false;
		this.peegeldatud = false;
		this.rotated = false;
		this.keeratud_esimene = false;
		this.keeratud_viimane = false;
		this.adasarea_distance = [];
		this.adasarea_type = [];

        this.initState(state);
	}

    /**
     * Initsialiseerib algoleku
     */
    initState(state: ProductConfig | ProductInfoType | ProductInfo): void {
        if (_.isObject(state)) this.extend(state);

        if (this.lineCount == null) this.lineCount = AppConfig.DEFAULT_LINE_COUNT;
        if (this.hudPoints == null) this.hudPoints = AppConfig.DEFAULT_HUD_POINTS;
        if (this.addPoints == null) this.addPoints = AppConfig.DEFAULT_ADD_POINTS;
        if (this.adasAreasCount == null) this.adasAreasCount = AppConfig.DEFAULT_ADAS_AREAS;
        if (this.angleCount == null) this.angleCount = AppConfig.ANGLE_COUNT;

        let productTransformer = new ProductTransformer(this);

        if (this.xnihe == null) this.xnihe = 0;
        if (this.ynihe == null) this.ynihe = 0;
        if (this.distants == null) this.distants = 0;
        if (this.valitud_e == null) this.valitud_e = 0;
        if (this.valitud_p == null) this.valitud_p = 0;
        if (this.valitud_hud == null) this.valitud_hud = 0;
        if (this.klaasiPaksus == null) this.klaasiPaksus = 0;
        if (this.profiilKlaasil == null) this.profiilKlaasil = 0;
        if (this.profiilTrykil == null) this.profiilTrykil = 0;
        if (this.keeratud == null) this.keeratud = false;
        if (this.peegeldatud == null) this.peegeldatud = false;
        if (this.keeratud_esimene == null) this.keeratud_esimene = false;
        if (this.keeratud_viimane == null) this.keeratud_viimane = false;
        if (this.angle == null) this.angle = {};

        if (this.tolerants1k == null) this.tolerants1k = AppConfig.DEFAULT_TOLERANCES[0]; // Keskmise punkti (P2, P5, P8) vaikimisi tolerants 1
        if (this.tolerants2k == null) this.tolerants2k = AppConfig.DEFAULT_TOLERANCES[1]; // Keskmise punkti (P2, P5, P8) vaikimisi tolerants 2
        if (this.tolerants1s == null) this.tolerants1s = AppConfig.DEFAULT_TOLERANCES[2]; // Otspunkti (P1, P3, P4, P6, P7, P9) vaikimisi tolerants 1
        if (this.tolerants2s == null) this.tolerants2s = AppConfig.DEFAULT_TOLERANCES[3]; // Otspunkti (P1, P3, P4, P6, P7, P9) vaikimisi tolerants 2
        if (this.tolerants1l == null) this.tolerants1l = AppConfig.DEFAULT_TOLERANCES[4]; // Lisapunkti (P50, P100, ...) vaikimisi tolerants 1
        if (this.tolerants2l == null) this.tolerants2l = AppConfig.DEFAULT_TOLERANCES[5]; // Lisapunkti (P50, P100, ...) vaikimisi tolerants 2
        if (this.tolerants1h == null) this.tolerants1h = AppConfig.DEFAULT_TOLERANCES[6]; // HUD punkti (H1, ...) vaikimisi tolerants 1
        if (this.tolerants2h == null) this.tolerants2h = AppConfig.DEFAULT_TOLERANCES[7]; // HUD punkti (H1, ...) vaikimisi tolerants 2


        for (let i = 0; i < this.lineCount*3 + this.addPoints; i++) {
            if (this.pNominaal.length <= i) this.pNominaal[i] = 10;
            if (this.pKorrektsioon.length <= i) this.pKorrektsioon[i] = 0;

            if (i < this.lineCount*3) {
                if (i % 3 == 1) {
                    // Keskmised punktid
                    if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1k;
                    if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1k;
                    if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2k;
                    if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2k;
                } else {
                    // Otsapunktid
                    if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1s;
                    if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1s;
                    if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2s;
                    if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2s;
                }
            } else {
                // Lisapunktid
                if (this.pYlemineTolerants1.length <= i) this.pYlemineTolerants1[i] = this.tolerants1l;
                if (this.pAlumineTolerants1.length <= i) this.pAlumineTolerants1[i] = this.tolerants1l;
                if (this.pYlemineTolerants2.length <= i) this.pYlemineTolerants2[i] = this.tolerants2l;
                if (this.pAlumineTolerants2.length <= i) this.pAlumineTolerants2[i] = this.tolerants2l;
            }
            if (this.pNimi.length <= i) this.pNimi[i] = productTransformer.getPointName(i);
            if (this.pJoon.length <= i) this.pJoon[i] = this.getLineNo(i);
            if (this.pOlemas.length <= i) this.pOlemas[i] = true;
        }

        for (let i = 0; i < this.hudPoints; i++) {
            if (this.hudNominaal.length <= i) this.hudNominaal[i] = 10;
            if (this.hudKorrektsioon.length <= i) this.hudKorrektsioon[i] = 0;

            if (this.hudYlemineTolerants1.length <= i) this.hudYlemineTolerants1[i] = this.tolerants1h;
            if (this.hudAlumineTolerants1.length <= i) this.hudAlumineTolerants1[i] = this.tolerants1h;
            if (this.hudYlemineTolerants2.length <= i) this.hudYlemineTolerants2[i] = this.tolerants2h;
            if (this.hudAlumineTolerants2.length <= i) this.hudAlumineTolerants2[i] = this.tolerants2h;
        }

        for (let i = 0; i < this.lineCount*2; i++) {
            if (this.ez.length <= i) this.ez[i] = 0;
            if (this.s.length <= i) this.s[i] = 0;
        }

        for (let i = 0; i < this.lineCount; i++) {
            if (this.pikkus.length <= i) this.pikkus[i] = 0;
        }

        for (let i = 0; i < this.adasAreasCount; i++) {
            if (this.adasarea_distance.length <= i) this.adasarea_distance[i] = 0;
            if (this.adasarea_type.length <= i) this.adasarea_type[i] = 0;
        }
    }

	/**
	 * Väärtustab objekti elemendid etteantud struktuuri baasilt
	 * @param data
	 */
	extend(data: ProductInfoType | ProductInfo): void {
		for (let item of _.keys(data)) {
			if (item === 'glass') {
				this.glass.extend(data.glass);
			} else if (Array.isArray(data[item])) {
				this[item] = data[item].slice();
			} else {
				this[item] = data[item];
			}
		}
	}

    /**
     * Tagastab punkti joone numbri offseti baasilt
     * @protected
     * @param {number} offset
     * @returns {number}
     */
    getLineNo(offset: IntegerType): IntegerType {
        if (offset < this.lineCount*3) {
            return Math.floor(offset / 3);
        } else {
            // Middle line:
            return Math.floor(this.lineCount / 2);
        }
    }

    calcGlass(): void {
		if (this.glass.tahvelx === 0) return;
		
		if (!_.isArray(this.joony) || this.joony.length == 0) this.calcJoonAY();
		if (!_.isArray(this.ex) || this.ex.length == 0) this.calcE();
		if (!_.isArray(this.px) || this.px.length == 0) this.calcP();
		if (!_.isArray(this.pikkus) || this.pikkus.length == 0) this.calcLengthE();
		if (!_.isArray(this.pv) || this.pv.length == 0) this.calcOffsetP();
        if (!_.isArray(this.hudv) || this.hudv.length == 0) this.calcOffsetHud();
        if (!_.isArray(this.hudx) || this.hudx.length == 0) this.calcHudV();
	}
	
	calcJoonAY(): void {
		let ncp = this.glass;
		let step = 1 / (this.lineCount + 1);
		let current = step;
		this.joona = [];
		this.joony = [];
		for (let i = 0; i < this.lineCount; i++) {
			this.joona[i] = this.joony[i] = ((ncp.maxx - ncp.minx) * current) + ncp.minx - ncp.keskx;
			current += step;
		}
	}

    calcE(): void {
		let ncp = this.glass;
		
		this.ex = [];
		this.ey = [];
		
		let abiex = [];
		let abiey = [];
		for (let i = 0; i < this.lineCount*2; i++) {
			abiex[i] = 0;
			abiey[i] = 0;
		}
		
		for (let l = 0; l < this.lineCount; l++) {
			let e_loendur = l*2;
			let x3 = this.joony[l];
			let y3 = ncp.maxy - ncp.kesky + 1;
			let x4 = this.joona[l];
			let y4 = ncp.miny - ncp.kesky - 1;
			
			for (let i = 0; i < ncp.ridu; i++) {
				let X1 = ncp.joonx1[i];
				let Y1 = ncp.joony1[i];
				let X2 = ncp.joonx2[i];
				let Y2 = ncp.joony2[i];
				
				let dx = X2 - X1;
				let dy = Y2 - Y1;
				let da = x4 - x3;
				let db = y4 - y3;
				
				if (da*dy - db*dx != 0.0) {
		            let s = (dx * (y3 - Y1) + dy * (X1 - x3)) / (da * dy - db * dx);
		            let t = (da * (Y1 - y3) + db * (x3 - X1)) / (db * dx - da * dy);
		            if (s >= 0.0 && s <= 1.0 && t >= 0.0 && t <= 1.0) {
		                abiex[e_loendur] = X1 + t * dx;
		                abiey[e_loendur] = Y1 + t * dy;
		                e_loendur++;
		            }
				}
			}
			
			if (abiey[e_loendur-2] > abiey[e_loendur-1]) {
				this.ex[l*2] = abiex[l*2];
				this.ey[l*2] = abiey[l*2];
				this.ex[l*2+1] = abiex[l*2+1];
				this.ey[l*2+1] = abiey[l*2+1];
			} else {
				this.ex[l*2] = abiex[l*2+1];
				this.ey[l*2] = abiey[l*2+1];
				this.ex[l*2+1] = abiex[l*2];
				this.ey[l*2+1] = abiey[l*2];
			}
		}
		
		for (let i = 0; i < this.lineCount*2; i++) {
			if (abiex[i] == 0 && abiey[i] == 0) {
				throw t("Error calculating E-points");
			}
		}
	}
	
	calcLengthE(): void {
		this.pikkus = [];
		for (let l = 0; l < this.lineCount; l++) {
			this.pikkus[l] = Math.round(Math.sqrt(Math.pow(this.ex[2*l+1] - this.ex[2 * l], 2) + Math.pow(this.ey[2*l+1] - this.ey[2 * l], 2)));
		}
	}

    /**
     * Arvutame punktid P, kasutades alusena ex, ey ja paigutades punktid P algolekusse
     */
	calcP(): void {
		this.px = [];
		this.py = [];
		let defaultOffset = this.getDefaultOffsetP();
		for (let l = 0; l < this.lineCount; l++) {
		    this.px[3 * l] = ((this.ex[2 * l] + this.ex[2*l+1]) / 2) + ((this.ex[2 * l] - this.ex[2*l+1]) / 3);
		    //this.py[3*l+0] = this.ey[2*l+0] - ((this.ey[2*l+0] + Math.abs(this.ey[2*l+1])) / 6);
            this.py[3 * l] = this.ey[2 * l] - defaultOffset;

		    this.px[3*l+1] = (this.ex[2 * l] + this.ex[2*l+1]) / 2;
		    this.py[3*l+1] = (this.ey[2 * l] + this.ey[2*l+1]) / 2;

		    this.px[3*l+2] = ((this.ex[2 * l] + this.ex[2*l+1]) / 2) + ((this.ex[2*l+1] - this.ex[2 * l]) / 3);
            //this.py[3*l+2] = this.ey[2*l+1] + ((this.ey[2*l+0] + Math.abs(this.ey[2*l+1])) / 6);
		    this.py[3*l+2] = this.ey[2*l+1] + defaultOffset;
		}

		this.calcPi();
	}

	calcPi(): void {
	    if (!this.addPoints) return;

        let l = Math.floor(this.lineCount / 2);
        let lineX = this.ex[2 * l] - this.ex[2 * l + 1];
        let lineY = this.ey[2 * l] - this.ey[2 * l + 1];
        let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));

        for (let i = this.lineCount*3, offset = 50; i < this.lineCount*3+this.addPoints; i++, offset += 50) {
            //let pv = lineLen - offset;
            let pv = offset;
            this.pv[i] = pv;
            this.px[i] = Math.round(this.ex[2 * l + 1] + pv * lineX / lineLen);
            this.py[i] = Math.round(this.ey[2 * l + 1] + pv * lineY / lineLen);
        }
    }

    /**
     * Arvutame punktid HUD, kasutades alusena ex, ey ja paigutades punktid HUD algolekusse
     */
    calcHud(): void {
        if (this.hudLine == null) return;

        this.hudx = [];
        this.hudy = [];
        this.hudv = [];

        let l = this.hudLine - 1;
        let lineX = this.ex[2 * l] - this.ex[2 * l + 1];
        let lineY = this.ey[2 * l] - this.ey[2 * l + 1];
        let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));

        for (let i = 0, offset = Math.round(lineLen - AppConfig.HUD_DEFAULT_OFFSET); i < this.hudPoints; i++, offset -= AppConfig.HUD_DEFAULT_STEP) {
            let pv = offset;
            this.hudv[i] = pv;
            this.hudx[i] = Math.round(this.ex[2 * l + 1] + pv * lineX / lineLen);
            this.hudy[i] = Math.round(this.ey[2 * l + 1] + pv * lineY / lineLen);
        }
    }

    getDefaultOffsetP(): number {
	    let centerLine = Math.floor(this.lineCount / 2);
	    let centerLen = this.getLineLen(centerLine);
	    return (centerLen >= 700 ? 200 : 150);
    }

    getLineLen(l): number {
        let lineX = this.ex[2 * l + 1] - this.ex[2 * l];
        let lineY = this.ey[2 * l + 1] - this.ey[2 * l];
        return Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));
    }

    /**
     * Arvutame punktid P, kasutades alusena ex, ey, pv
     */
    calcPV(): void {
        // Arvutame px, py, kasutades alusena pv, ex, ey infot:
        this.px = [];
        this.py = [];
        let ex = this.ex;
        let ey = this.ey;
        let pv = this.pv;
        for (let i = 0; i < this.px.length; i++) {
            let l = this.pJoon[i];

            let lineX = ex[2 * l] - ex[2 * l + 1];
            let lineY = ey[2 * l] - ey[2 * l + 1];
            let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));

            this.px[i] = Math.round(ex[2 * l + 1] + pv[i] * lineX / lineLen);
            this.py[i] = Math.round(ey[2 * l + 1] + pv[i] * lineY / lineLen);
        }
    }

    /**
     * Arvutame punktid HUD, kasutades alusena ex, ey, hudv
     */
    calcHudV(): void {
        if (this.hudLine == null) return;

        // Arvutame hudx, hudy, kasutades alusena hudv, ex, ey infot:
        this.hudx = [];
        this.hudy = [];

        let ex = this.ex;
        let ey = this.ey;
        let hudv = this.hudv;
        let l = this.hudLine - 1;
        for (let i = 0; i < hudv.length; i++) {

            let lineX = ex[2 * l] - ex[2 * l + 1];
            let lineY = ey[2 * l] - ey[2 * l + 1];
            let lineLen = Math.sqrt(Math.pow(lineX, 2) + Math.pow(lineY, 2));

            this.hudx[i] = Math.round(ex[2 * l + 1] + hudv[i] * lineX / lineLen);
            this.hudy[i] = Math.round(ey[2 * l + 1] + hudv[i] * lineY / lineLen);
        }
    }

    calcOffsetP(): void {
		this.pv = [];
        for (let i = 0; i < this.px.length; i++) {
            let l = this.pJoon[i];
            this.pv[i] = Math.round(
                Math.sqrt(
                    Math.pow((this.px[i] - this.ex[2*l+1]), 2) +
                    Math.pow((this.py[i] - this.ey[2*l+1]), 2)
                )
            );
        }
	}

    calcOffsetHud(): void {
        if (this.hudLine == null) return;

        this.hudv = [];

        let l = this.hudLine - 1;
        for (let i = 0; i < this.hudx.length; i++) {
            this.hudv[i] = Math.round(
                Math.sqrt(
                    Math.pow((this.hudx[i] - this.ex[2*l+1]), 2) +
                    Math.pow((this.hudy[i] - this.ey[2*l+1]), 2)
                )
            );
        }
    }

    /**
	 * Call koordinaadid
	 */
	calcKoord(kalle?: ?boolean): void {

		this.calcOffsetP();
        this.calcOffsetHud();

		if (kalle === undefined || kalle !== false) this.calcKalle();
		
		this.pikkus = [];
		for (let i = 0; i < this.lineCount; i++) {
			this.pikkus[i] = Math.round(Math.sqrt(Math.pow(this.ex[i*2+1] - this.ex[i*2], 2) +
				Math.pow(this.ey[i*2+1] - this.ey[i*2], 2)));
		}
	}
	
	/**
	 * Sub arvuta_Kalle
	 */
	calcKalle(): void {
		let settings = Settings.getInstance();
		let KALDE_TEGUR = settings.getSlopeFactor();

		// eKalleA - x-telje suunaline (keskmisel joonel 0)
		// eKalleB - y-telje suunaline
		let eKalleA = [];
		let eKalleB = [];

		for (let i = 0; i < this.lineCount*2; i++) {
			// KalleA
			if (i == this.lineCount-1 || i == this.lineCount) {
				// Keskmisel joonel on kalle A 0
				// TODO: Nihutatud keskmise joone korral enam ei ole kalle 0...
				eKalleA[i] = 0;
			} else {
				let p1 = (i > this.lineCount ? i   : i+2 );
				let p2 = (i > this.lineCount ? i-2 : i   );
				let a = (this.ez[p1] - this.ez[p2]);
				let b = Math.sqrt(Math.pow(this.ex[p1] - this.ex[p2], 2) + Math.pow(this.ey[p1] - this.ey[p2], 2));
				let tmp =  a / b;
				let atan = Math.atan(tmp);
				eKalleA[i] = Math.round((atan * 180.0 / Math.PI)*10.0) * KALDE_TEGUR / 10.0;
			}
			
			if (i % 2 == 0) {
				// KalleB (1,3,5) -> (2,5,8) | (0,2,4) -> (1,4,7) i -> i/2*3+1
				let pi = i/2*3+1;
			    let tmp = this.pNominaal[pi] / Math.sqrt(Math.pow(this.px[pi] - this.ex[i], 2) + Math.pow(this.py[pi] - this.ey[i], 2));
			    eKalleB[i] = Math.round(((Math.atan(tmp)) * 180 / Math.PI)*10.0) * KALDE_TEGUR / 10.0;
			} else {
				eKalleB[i] = eKalleB[i-1] * -1.0;
			}
		}
		this.eKalleA = eKalleA;
		this.eKalleB = eKalleB;
	}

	copyKalle(): void {
		for (let i = 0; i < Math.floor(this.lineCount/2); i++) {
			let mirroredLine = this.lineCount - i - 1;
			this.eKalleA[mirroredLine*2] =   -this.eKalleA[i*2];
			this.eKalleA[mirroredLine*2+1] = -this.eKalleA[i*2+1];
			this.eKalleB[mirroredLine*2] =    this.eKalleB[i*2];
			this.eKalleB[mirroredLine*2+1] =  this.eKalleB[i*2+1];
		}
	}

	mirror(): void {
		for (let i = 0; i < Math.floor(this.lineCount/2); i++) {
			this.joona[this.lineCount-i-1] = Math.abs(this.joona[i]);
			this.joony[this.lineCount-i-1] = Math.abs(this.joony[i]);

			this.ez[2*(this.lineCount-i)-2] = this.ez[2*i];
			this.ez[2*(this.lineCount-i)-1] = this.ez[2*i+1];
			this.s[2*(this.lineCount-i)-2] = this.s[2*i];
			this.s[2*(this.lineCount-i)-1] = this.s[2*i+1];

			this.pv[3*(this.lineCount-i)-3] = this.pv[3*i];
			this.pv[3*(this.lineCount-i)-2] = this.pv[3*i+1];
			this.pv[3*(this.lineCount-i)-1] = this.pv[3*i+2];
		}

		// TODO: Miks see nii tehakse? Vt ncp2gr-fi.frm rida 3773 (Sub Command7_Click)
		/*
		let mid = Math.floor(this.lineCount*3 / 2);
		this.px[mid] = Math.abs(this.px[0]);
		this.py[mid] = this.py[0];
		*/
		this.calcE();
		this.calcPfromOffset();
        this.calcHudFromOffset();
	}

	mirrorShape(): void {
		this.glass.mirror();
	}

	moveE(point: IntegerType, offset: IntegerType): void {
		// Paaritud on ülemised, paaris on alumised:
		let joon = ( point % 2 == 0 ? this.joony : this.joona );
		// Joone indeks on punkti nr / 2:
		let idx = Math.floor(point / 2);
		
		joon[idx] += offset;
		
		// Kontrollime, et jooned ei liiguks üle üksteise ega üle servade:
		let minx = this.glass.minx - this.glass.keskx;
		let maxx = this.glass.maxx - this.glass.keskx;
		if (idx > 0) minx = joon[idx-1];
		if (idx < this.lineCount-1) maxx = joon[idx+1];
		if (joon[idx] < minx) joon[idx] = minx;
		if (joon[idx] > maxx) joon[idx] = maxx;
		
		this.calcE();
		this.calcPfromOffset();
        this.calcHudFromOffset();
	}
	
	moveP(point: IntegerType, offset: IntegerType): void {
		// Keskmisi punkte nihutada ei luba:
		//if (point % 3 == 1) return;
		
		// Leiame x vahemiku, mille sees tohib muutuda:
        let line = this.pJoon[point];
		// let line = Math.floor(point / 3);
        let maxy = this.ey[line * 2];
        let miny = this.ey[line * 2 + 1];
        let minx = this.ex[line * 2 + 1];
        if (point < this.lineCount*3) {
            if (point % 3 != 0) maxy = this.py[point-1];
            else {
                miny = this.py[point+1];
                minx = this.px[point+1];
            }
        }

        if (this.py[point] == null || this.py[point] < miny) {
            this.py[point] = miny;
            this.px[point] = minx;
        }

		if (this.py[point]+offset > miny && this.py[point]+offset < maxy) {
			this.py[point] += offset;
			this.px[point] = this.px[point] + ((this.ex[line*2] - this.ex[line*2+1]) / (this.ey[line*2] - this.ey[line*2+1])) * offset;
		}
	}

    moveHud(point: IntegerType, offset: IntegerType): void {
        if (this.hudLine == null) return;

        // Leiame x vahemiku, mille sees tohib muutuda:
        let line = this.hudLine - 1;
        let maxy = this.ey[line * 2];
        let miny = this.ey[line * 2 + 1];
        let minx = this.ex[line * 2 + 1];

        if (this.hudy[point] == null || this.hudy[point] < miny) {
            this.hudy[point] = miny;
            this.hudx[point] = minx;
        }

        if (this.hudy[point]+offset > miny && this.hudy[point]+offset < maxy) {
            this.hudy[point] += offset;
            this.hudx[point] = this.hudx[point] + ((this.ex[line*2] - this.ex[line*2+1]) / (this.ey[line*2] - this.ey[line*2+1])) * offset;
        }
    }

    removeP(point: IntegerType): void {
		this.pOlemas[point] = !this.pOlemas[point];
	}

	assignP(): void {
		// punkti P200 järgi, kui joon E3-E4 >= 700 mm,
        // punkti P150 järgi, kui joon E3-E4 < 700 mm.
		let centerLine = Math.floor(this.lineCount/2);
		let pointName = (this.getLineLen(centerLine) >= 700 ? "P200" : "P150");
		for (let i = 0; i < this.pNimi.length; i++) {
			if (this.pNimi[i] == pointName) {
                let centerLineLastPoint = 3*Math.floor(this.lineCount/2 + 1) - 1;
				this.px[centerLineLastPoint] = this.px[i];
				this.py[centerLineLastPoint] = this.py[i];
				this.pNominaal[centerLineLastPoint] = this.pNominaal[i];
				this.pAlumineTolerants1[centerLineLastPoint] = this.pAlumineTolerants1[i];
				this.pAlumineTolerants2[centerLineLastPoint] = this.pAlumineTolerants2[i];
				this.pYlemineTolerants1[centerLineLastPoint] = this.pYlemineTolerants1[i];
				this.pYlemineTolerants2[centerLineLastPoint] = this.pYlemineTolerants2[i];
				this.pv[centerLineLastPoint] = this.pv[i];
				break;
			}
		}
	}

	calcPfromOffset(): void {
		this.px = [];
		this.py = [];
		for (let i = 0; i < this.pJoon.length; i++) {
		    let l = this.pJoon[i];
            let ev = Math.sqrt(((this.ex[2*l] - this.ex[2*l+1]) * (this.ex[2*l] - this.ex[2*l+1])) + ((this.ey[2*l] - this.ey[2*l+1]) * (this.ey[2*l] - this.ey[2*l+1])));
            this.px[i] = this.ex[2*l+1] + Math.round(this.pv[i]*(this.ex[2*l]-this.ex[2*l+1])/ev);
            this.py[i] = this.ey[2*l+1] + Math.round(this.pv[i]*(this.ey[2*l]-this.ey[2*l+1])/ev);
        }
	}

    calcHudFromOffset(): void {
        if (this.hudLine == null) {
            if (this.hudv.length > 0) {
                this.hudx = [];
                this.hudy = [];
                this.hudv = [];
            }
            return;
        }

        this.hudx = [];
        this.hudy = [];

        if (this.hudv.length == 0) this.calcHud();
        else {
            let l = this.hudLine - 1;
            for (let i = 0; i < this.hudPoints; i++) {
                let ev = Math.sqrt(((this.ex[2*l] - this.ex[2*l+1]) * (this.ex[2*l] - this.ex[2*l+1])) + ((this.ey[2*l] - this.ey[2*l+1]) * (this.ey[2*l] - this.ey[2*l+1])));
                this.hudx[i] = this.ex[2*l+1] + Math.round(this.hudv[i]*(this.ex[2*l]-this.ex[2*l+1])/ev);
                this.hudy[i] = this.ey[2*l+1] + Math.round(this.hudv[i]*(this.ey[2*l]-this.ey[2*l+1])/ev);
            }
        }
    }

    calcPointsAngle(i, j): void {
		// Meil on vaja teada mõlema punkti (y, z) koordinaate.
		if (this.pv[i] == null || this.pv[j] == null || this.pNominaal[i] == null || this.pNominaal[j] == null) {
			this.angleValue = null;
			return;
		}
		this.angleValue = calcAngle(this.pv[i], this.pNominaal[i], this.pv[j], this.pNominaal[j]);
	}
}

export default ProductInfo;
